import React from 'react';
import './Card.css';  

function Card({ image, title, text, reverse }) {
  return (
    <div className={`card ${reverse ? 'reverse' : ''}`}>
      <div className="card-image">
        <img src={image} alt="Card" />
      </div>
      <div className="card-text">
        <h4 className="card-title">{title}</h4>
        <p className="card-body">{text}</p>
      </div>
    </div>
  );
}

export default Card;